import { Navigate, Outlet } from "react-router";

import { PathNamekRoutes } from "../../../router/constants";
import { PermissionCheck, usePermissionCheck } from "../hooks/usePermissionCheck.hook";

type Props = PermissionCheck & {
  children: React.ReactNode;
  redirectPath?: string;
};

const GuardRoute = ({ children, redirectPath = PathNamekRoutes.UNAUTHORIZED, ...props }: Props) => {
  const isAllowed = usePermissionCheck(props);

  if (!isAllowed) {
    return <Navigate replace={true} to={`/${redirectPath}`} />;
  }

  return children ? children : <Outlet />;
};

export default GuardRoute;
